import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { Alert, Button, Modal, ModalBody, ModalHeader, Spinner } from 'reactstrap';
import TextInput from '../../pages/components/inputs/TextInput';
import { useSelector } from 'react-redux';
import { tenant_auth_actions_helper } from '../../actions/actions_helper';
import { fail_add_product, loading_add_product, reset_add_product, success_add_product } from '../../reducers/auth_tenant/add_product_Slice';
import { ADD_PRODUCT_ERROR_MSG, ADD_PRODUCT_SUCCESS_MSG, RETRIEVE_BRANDS_ERROR_MSG, RETRIEVE_BRANDS_SUCCESS_MSG } from '../../utils/error_success_messages';
import { CREATE_PRODUCT_API, RETRIEVE_TENANT_BRANDS_SETTINGS_API, RETRIEVE_TENANT_SYSTEM_BRANDS_API } from '../../api/api_data';
import { getSelectedOption, messageToast } from '../../utils/Utils';
import { Col, Icon, Row, RSelect } from '../Component';
import * as app_consts from "../../utils/app_consts";
import { fail_retrieve_brands_list, loading_retrieve_brands_list, reset_retrieve_brands_list, success_retrieve_brands_list } from '../../reducers/auth_tenant/retrieve_brands_list_Slice';
import { reset_retrieve_brands_settings } from '../../reducers/auth_tenant/retrieve_brands_settings_Slice';

const initialState = { category: "", returnable: "", name: "", product_type: "", packet_sizes: [], colors: [], product_image: "", sku_no: "" };

const AddProductModal = ({ tenant_info, user_info, isOpen, successFunction, closeModal, data }) => {

 const [open, setOpen] = useState(isOpen);
 const [add_product_loading, setAddProductLoading] = useState(false);
 const [add_product_error, setAddProductError] = useState("");
 const dispatch = useDispatch();
 const navigate = useNavigate();
 const [formData, setFormData] = useState(initialState);
 const fileInputRef = useRef(null); // Reference for file input

 const handleReUploadClick = () => {
  fileInputRef.current.click(); // Programmatically click the file input
 };

 const [inputPacketSizeValue, setInputPacketSizeValue] = useState("");
 const [bubblesPacketSize, setBubblesPacketSize] = useState([]);

 const [inputColourseValue, setInputColoursValue] = useState("");
 const [bubblesColours, setBubblesColours] = useState([]);

 const [brands, setBrands] = useState([]);
 const [brands_loading, setBrandsLoading] = useState(false);

 useEffect(() => {
  setOpen(isOpen);

  //
  if (isOpen)
  {
   setFormData(initialState);
   setBubblesPacketSize([]);
   setBubblesColours([]);
   retrieve_brands();
  }

 }, [isOpen]);

 const retrieve_brands = () => {
  dispatch(tenant_auth_actions_helper(loading_retrieve_brands_list, success_retrieve_brands_list, fail_retrieve_brands_list, RETRIEVE_BRANDS_ERROR_MSG, RETRIEVE_BRANDS_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_TENANT_SYSTEM_BRANDS_API}`));
 };

 // Listener
 const retrieve_brands_list_listener = useSelector((state) => state.retrieve_brands_list.retrieve_brands_list);

 useEffect(() => {
  if (retrieve_brands_list_listener.status !== app_consts.IDLE)
  {
   if (retrieve_brands_list_listener.status === app_consts.LOADING)
   {
    setBrandsLoading(true);
   } else
   {
    setBrandsLoading(false);
    if (retrieve_brands_list_listener.status === app_consts.FAIL)
    {
     messageToast(retrieve_brands_list_listener.message, app_consts.FAIL);
    } else if (retrieve_brands_list_listener.status === app_consts.SUCCESS)
    {
     const remap_brands = retrieve_brands_list_listener.data?.settings?.map((set) => { return { value: set, label: set }; });
     setBrands(remap_brands);
    }
    dispatch(reset_retrieve_brands_list());
   }
  }
 }, [retrieve_brands_list_listener]);

 // Handle Change Function
 const handleChange = (e) => {
  setFormData({ ...formData, [e.target.name]: e.target.value });
 };

 const handleSubmit = () => {
  setAddProductError("");
  // Dispatch
  dispatch(tenant_auth_actions_helper(loading_add_product, success_add_product, fail_add_product, ADD_PRODUCT_ERROR_MSG, ADD_PRODUCT_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${CREATE_PRODUCT_API}`, formData));
 };
 // Listen
 const add_product_listener = useSelector((state) => state.add_product.add_product);

 useEffect(() => {
  if (add_product_listener.status !== app_consts.IDLE)
  {
   if (add_product_listener.status === app_consts.LOADING)
   {
    setAddProductLoading(true);
    setAddProductError("");
   } else
   {
    setAddProductLoading(false);
    if (add_product_listener.status === app_consts.FAIL)
    {
     setAddProductError(add_product_listener.message, app_consts.FAIL);
     messageToast(add_product_listener.message, app_consts.FAIL);
    } else if (add_product_listener.status === app_consts.SUCCESS)
    {
     messageToast(add_product_listener.message, app_consts.SUCCESS);
     successFunction();
     closeModal();
    }
    dispatch(reset_add_product());
   }
  }
 }, [add_product_listener]);

 const handlePacketSizeKeyDown = (e) => {
  if (e.key === "Enter" && inputPacketSizeValue.trim())
  {
   setBubblesPacketSize([...bubblesPacketSize, inputPacketSizeValue.trim()]);
   setFormData({ ...formData, ["packet_sizes"]: [...bubblesPacketSize, inputPacketSizeValue.trim()] });
   setInputPacketSizeValue(""); // Clear input
  }
 };

 const removePacketSizeBubble = (index) => {
  setBubblesPacketSize(bubblesPacketSize.filter((_, i) => i !== index));
  setFormData({ ...formData, ["packet_sizes"]: bubblesPacketSize.filter((_, i) => i !== index) });
 };

 const handleColorKeyDown = (e) => {
  if (e.key === "Enter" && inputColourseValue.trim())
  {
   setBubblesColours([...bubblesColours, inputColourseValue.trim()]);
   setFormData({ ...formData, ["colors"]: [...bubblesColours, inputColourseValue.trim()] });
   setInputColoursValue(""); // Clear input
  }
 };

 const removeColorsBubble = (index) => {
  setBubblesColours(bubblesColours.filter((_, i) => i !== index));
  setFormData({ ...formData, ["colors"]: bubblesColours.filter((_, i) => i !== index) });
 };


 const handleImageUpload = (event) => {
  const file = event.target.files[0];

  if (file)
  {
   const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];

   if (!allowedTypes.includes(file.type))
   {
    messageToast("Please select a valid image file (PNG, JPEG, JPG.", app_consts.FAIL);
    return;
   }

   setFormData({ ...formData, ["product_image"]: file });
  }
 };

 return (
  <>
   < Modal isOpen={open} className="modal-dialog-centered" size={"lg"} >
    <ModalHeader toggle={add_product_loading ? "" : closeModal}>Add Product</ModalHeader>
    <ModalBody>
     <Row className="g-4">

      <Col size={6}>
       <div className="form-group">
        <label className="form-label mb-1 text-md" htmlFor="retrunable">
         Brand<span className='text-danger pr-2'>{` *`}</span>
        </label>
        <div className="w-100">
         <RSelect
          options={brands}
          className="w-100"
          placeholder="Search"
          id="retrunable"
          isDisabled={brands_loading}
          onChange={(e) => {
           setFormData({ ...formData, ["category"]: e.value });
          }}
          value={getSelectedOption(formData.category, brands)}
         />
        </div>
       </div>
      </Col>
      <TextInput
       label="Product Name"
       type="text"
       id_val="name"
       value={formData.name}
       colSize="6"
       name="name"
       handleChange={handleChange}
      />
      <TextInput
       label="Product Type"
       type="text"
       id_val="product_type"
       value={formData.product_type}
       colSize="6"
       name="product_type"
       handleChange={handleChange}
      />
      <TextInput
       label="SKU (Optional)"
       type="text"
       id_val="sku_no"
       value={formData.sku_no}
       colSize="6"
       name="sku_no"
       handleChange={handleChange}
      />
      <Col size={6}>
       <div className="form-group">
        <label className="form-label mb-1 text-md" htmlFor="retrunable">
         Returnable<span className='text-danger pr-2'>{` *`}</span>
        </label>
        <div className="w-100">
         <RSelect
          options={[{ label: "Returnable", value: true }, { label: "Non-Returnable", value: false }]}
          className="w-100"
          placeholder="Search"
          id="retrunable"
          onChange={(e) => {
           setFormData({ ...formData, ["returnable"]: e.value });
          }}
         />
        </div>
       </div>
      </Col>
      <Col size={6}>
       <TextInput
        label="Sizes"
        type="text"
        id_val="packet_size"
        value={inputPacketSizeValue}
        colSize="12"
        name="packet_size"
        handleChange={(e) => setInputPacketSizeValue(e.target.value)}
        onKeyDown={handlePacketSizeKeyDown}
        helper="Type and press Enter..."
       />
       <div style={styles.bubbleContainer} className='mt-2'>
        {bubblesPacketSize.map((text, index) => (
         <div key={index} className='bg-primary' style={styles.bubble}>
          {text}
          <span style={styles.close} onClick={() => removePacketSizeBubble(index)}>
           &times;
          </span>
         </div>
        ))}
       </div>
      </Col>
      <Col size={6}>
       <TextInput
        label="Colors"
        type="text"
        id_val="name"
        value={inputColourseValue}
        colSize="12"
        name="color"
        handleChange={(e) => setInputColoursValue(e.target.value)}
        onKeyDown={handleColorKeyDown}
        helper="Type and press Enter..."
       />
       <div style={styles.bubbleContainer} className='mt-2'>
        {bubblesColours.map((text, index) => (
         <div key={index} className='bg-primary' style={styles.bubble}>
          {text}
          <span style={styles.close} onClick={() => removeColorsBubble(index)}>
           &times;
          </span>
         </div>
        ))}
       </div>
      </Col>
      <div className="product-thumb" style={{ height: '250px', width: '100%', position: 'relative' }}>
       {formData.product_image ? (
        <>
         <img
          src={URL.createObjectURL(formData.product_image)}
          alt="Uploaded Logo"
          style={{ width: '100%', height: '100%', objectFit: 'contain' }}
         />
        </>
       ) : (
        <label htmlFor="imageUpload" style={{
         width: '100%',
         height: '100%',
         display: 'flex',
         justifyContent: 'center',
         alignItems: 'center',
         backgroundColor: '#f0f0f0',
         textAlign: 'center',
         border: '1px dashed #ccc',
         fontSize: '18px',
         fontWeight: 'bold',
         fontFamily: 'Arial, sans-serif',
         flexDirection: "column",
         cursor: 'pointer'
        }}>
         <p style={{ margin: 0, padding: '5px' }}>Click to Select Image</p>
        </label>
       )}

       <input
        type="file"
        id="imageUpload"
        accept="image/png, image/jpeg, image/jpg"
        style={{ display: 'none' }}
        onChange={handleImageUpload}
        ref={fileInputRef} // Assign ref
       />
      </div>
      <div className={`d-flex flex-row ${formData?.product_image ? "justify-content-start" : "justify-content-start"} mt-4`}>
       {
        formData?.product_image && (
         <>
          <Button color="primary" size="md" onClick={handleReUploadClick}>
           Re-upload
          </Button>
         </>
        )
       }
      </div>
      {add_product_error && (
       <div className="mb-3 w-100">
        <Alert color="danger" className="alert-icon">
         <Icon name="alert-circle" /> {add_product_error}{" "}
        </Alert>
       </div>
      )}
      <Col xl="12" className="d-flex justify-content-end mt-2 mr-2">
       <Button onClick={handleSubmit} disabled={add_product_loading || !(formData?.category && formData?.name && formData?.product_type && formData?.packet_sizes?.length > 0 && formData?.colors?.length > 0 && formData?.product_image)} color="primary">
        {add_product_loading ? <Spinner size="sm" color="light" /> : "Add Product"}
       </Button>
      </Col>
     </Row>
    </ModalBody>
   </Modal >
  </>
 );
};

const styles = {
 container: {
  display: "flex",
  flexDirection: "column",
  width: "300px",
  gap: "8px",
  border: "1px solid #ccc",
  padding: "10px",
  borderRadius: "8px",
 },
 bubbleContainer: {
  display: "flex",
  flexWrap: "wrap",
  gap: "5px",
 },
 bubble: {
  display: "flex",
  alignItems: "center",
  color: "white",
  padding: "5px 10px",
  borderRadius: "15px",
  fontSize: "14px",
 },
 close: {
  marginLeft: "8px",
  cursor: "pointer",
  fontWeight: "bold",
 },
 input: {
  width: "100%",
  padding: "8px",
  border: "1px solid #ccc",
  borderRadius: "4px",
 },
};

export default AddProductModal;